// Single source of truth mapping a route to the quote-dialog prefill.
// Service strings MUST match options in SERVICES (lib/contact.js).
// Community/project are only prefilled when verified for that route.

export const ROUTE_PREFILL = {
  // Service pages
  "/property-snagging-dubai": { service: "Snagging inspection" },
  "/handover-inspection-dubai": { service: "Handover inspection" },
  "/commercial-property-inspection-dubai": { service: "Commercial inspection", property_type: "Commercial" },
  "/apartment-inspection-dubai": { service: "Snagging inspection", property_type: "Apartment" },
  "/villa-inspection-dubai": { service: "Snagging inspection", property_type: "Villa" },
  "/resale-property-inspection-dubai": { service: "Resale property inspection" },
  "/property-inspection-abu-dhabi": { service: "Snagging inspection", emirate: "Abu Dhabi" },
  "/property-inspection-sharjah": { service: "Snagging inspection", emirate: "Sharjah" },
  "/dlp-warranty-inspection-dubai": { service: "DLP / warranty inspection" },

  // Community pages
  "/property-snagging-al-furjan": { service: "Snagging inspection", community: "Al Furjan" },
  "/property-snagging-sobha-hartland": { service: "DLP / warranty inspection", community: "Sobha Hartland" },
  "/property-snagging-central-park-city-walk": { service: "Snagging inspection", community: "Central Park at City Walk" },
  "/property-snagging-madinat-jumeirah-living": { service: "Snagging inspection", community: "Madinat Jumeirah Living" },
  "/property-snagging-sobha-hartland-2": { service: "Snagging inspection", community: "Sobha Hartland II" },
  "/property-snagging-sobha-one": { service: "Snagging inspection", community: "Sobha One", project: "Sobha One" },
  "/property-snagging-sobha-reserve": { service: "Snagging inspection", community: "Sobha Reserve" },
  "/property-snagging-jumeirah-lake-towers": { service: "Snagging inspection", community: "Jumeirah Lake Towers (JLT)" },
  "/property-snagging-damac-lagoons": { service: "Snagging inspection", community: "DAMAC Lagoons" },
  "/dlp-inspection-azizi-riviera": { service: "DLP / warranty inspection", community: "Azizi Riviera", project: "Azizi Riviera" },
  "/property-snagging-dubai-hills-estate": { service: "Snagging inspection", community: "Dubai Hills Estate" },
};

export function prefillFor(path = "") {
  const clean = "/" + path.replace(/^\/+|\/+$/g, "");
  return ROUTE_PREFILL[clean] || null;
}
